import React, {useState, useEffect, useRef} from 'react';
import KeyboardDoubleArrowDownOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowDownOutlined';
import BackupTableOutlinedIcon from '@mui/icons-material/BackupTableOutlined';
import {
    Button,
    Grid,
    Accordion,
    AccordionSummary,
    AccordionDetails, FormControlLabel, Checkbox, CircularProgress, Box, Radio,
} from '@mui/material';
import {
    fetchTotalRevenueReportData,
    fetchDspCompanies,
    getCsvTemplate,
    fetchStatisticFieldsTotalRevenue,
    fetchDataFieldsTotalRevenue,
} from '../../../../API/FinancialTools';
import MonthPickerComponent from '../../../../components/date/MonthPickerComponent';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import {sendDataToApi, sendJsonToApi} from '../../../../API/apiHelper';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import SelectMulti from '../../../../components/select/SelectMulti';
import {fetchAccManagers} from '../../../../API/AdminUserControl';
import UploadFileDialog from '../components/UploadFileDialog';
import CreateRowDialog from '../components/CreateRowDialog';
import useApi from '../../../../hooks/useApi';
import Picker from 'react-month-picker'
import {toast} from 'react-toastify';
import Cookies from 'js-cookie';
import axios from "axios";
import { FINANCIAL_PLATFORMS } from '../../../../constants/financialPlatforms';

function TotalRevenueOptionsForm({onSubmit}) {
    
    const {data: statistics, loading: loadingStats} = useApi(fetchStatisticFieldsTotalRevenue);
    const {data: templateLink, loading: loadingTemplateLink} = useApi(getCsvTemplate);
    const {data: data, loading: loadingData} = useApi(fetchDataFieldsTotalRevenue);
    const {data: dspCompany, loading: loadingCompany} = useApi(fetchDspCompanies);

    const {data: managers, loading: loadingManagers} = useApi(fetchAccManagers);

    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const [showAdvertiser, setShowAdvertiser] = useState(false);
    const [showPlatform, setShowPlatform] = useState(false);
    const [showManager, setShowManager] = useState(false);
    const [openCreate, setOpenCreate] = useState(false);
    const [openUpload, setOpenUpload] = useState(false);
    const [showStatus, setShowStatus] = useState(false);

    const [selectedAdvertiser, setSelectedAdvertiser] = useState('');
    const [selectedPlatform, setSelectedPlatform] = useState('');
    const [selectedManager, setSelectedManager] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('');

    function getPreviousMonthString() {
        const currentDate = new Date();
        const previousMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1);
        const year = previousMonthDate.getFullYear();
        const month = (previousMonthDate.getMonth() + 1).toString().padStart(2, '0');
        return `${year}-${month}`;
    }

    const [platform, setPlatform] = useState([...FINANCIAL_PLATFORMS]);
    const [status, setStatus] = useState([
        {name: 'New', id: 'new'},
        {name: 'Approved', id: 'approved'}
    ]);
    const handleCloseCreate = () => setOpenCreate(false);
    const handleClickOpenCreate = () => setOpenCreate(true);
    const handleCloseUpload = () => setOpenUpload(false);
    const handleClickOpenUpload = () => setOpenUpload(true);

    const [options, setOptions] = useState({
        stats: [],
        month: null,
        manager: '',
        platform: '',
        status: '',
        advertiser: '',
    });

    const [month, setMonth] = useState(null);
    const handleMonthChange = (selectedMonth) => {
        setMonth(selectedMonth);
    };

    const [showCalendar, setShowCalendar] = useState(false);


    const dropDownRef = useRef(null);
    const pickerRef = useRef(null);

    const handleCheckboxChange = (event) => {
        const {name} = event.target;
        setOptions({...options, fields: name});
    };

    useEffect(() => {
        const storedValue = Cookies.get('TotalRevenue');
        if (storedValue) {
            const parsedValue = JSON.parse(storedValue);
            setOptions(parsedValue);
        }

    }, []);

    useEffect(() => {
        setOptions({...options, month: month});
    }, [month]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const element = document.querySelector('.unique-month-picker-class')
            if (element && !element.contains(event.target)) {
                setShowCalendar(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    const toggleCalendar = () => {
        if (showCalendar === false) {
            setShowCalendar(true);
        } else {
            setShowCalendar(false);
        }
    };

    const handleCheckboxChangeStat = (event) => {
        const {name, checked} = event.target;
        let stats = [...options.stats];

        if (checked) {
            stats.push(name);
        } else {
            stats = stats.filter((satat) => satat !== name);
        }

        setOptions({...options, stats});
    };

    const handleSubmit = async (event) => {
        onSubmit(options);
    };

    useEffect(() => {
        setOptions((prevOptions) => ({
            ...prevOptions,
            manager: [selectedManager],
        }));
    }, [selectedManager]);

    useEffect(() => {
        setOptions((prevOptions) => ({
            ...prevOptions,
            platform: [selectedPlatform],
        }));
    }, [selectedPlatform]);

    useEffect(() => {
        setOptions((prevOptions) => ({
            ...prevOptions,
            status: [selectedStatus],
        }));
    }, [selectedStatus]);

    useEffect(() => {
        setOptions((prevOptions) => ({
            ...prevOptions,
            advertiser: [selectedAdvertiser],
        }));
    }, [selectedAdvertiser]);


    return (
        <Grid container spacing={2} sx={{width: "100%", marginLeft: '0px',}}>
            <Accordion sx={{width: "100%"}}>
                <AccordionSummary
                    expandIcon={<KeyboardDoubleArrowDownOutlinedIcon/>}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    sx={{backgroundColor: '#f0f3f5', width: "100%"}}
                >
                    Options
                </AccordionSummary>
                <AccordionDetails sx={{width: "100%"}}>
                    <form onSubmit={handleSubmit}>
                        <Grid item xs={12} md={12} sx={{width: "100%"}}>
                            <Grid item xs={12} md={12} sx={{width: "100%", margin: '25px 0 25px auto'}}>

                                <Grid item xs={12} md={12}>
                                    {Object.keys(statistics).length != 0 ? (<strong>Statistic</strong>) : ''}
                                </Grid>
                                {statistics.map((statistic, index) => (
                                    <FormControlLabel
                                        key={index}
                                        control={
                                            <Checkbox
                                                checked={options.stats.includes(statistic.key)}
                                                onChange={handleCheckboxChangeStat}
                                                name={statistic.key}
                                            />
                                        }
                                        label={statistic.value}
                                    />
                                ))}

                            </Grid>

                            <Grid item xs={12} md={12} sx={{width: "100%", margin: '25px 0 25px auto'}}>

                                <Grid item xs={12} md={12}>
                                    {Object.keys(data).length != 0 ? (<strong>Data</strong>) : ''}
                                </Grid>
                                {data.map((statistic, index) => (
                                    <FormControlLabel
                                        key={index}
                                        control={
                                            <Checkbox
                                                checked={options.stats.includes(statistic.key)}
                                                onChange={handleCheckboxChangeStat}
                                                name={statistic.key}
                                            />
                                        }
                                        label={statistic.value}
                                    />
                                ))}

                            </Grid>

                            <Grid item xs={12} md={12} sx={{width: "100%", margin: '25px 0 25px auto'}}>
                                <Grid item xs={12} md={12}>
                                    <strong>Filters</strong>
                                </Grid>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={12}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={showPlatform}
                                                    onChange={() => setShowPlatform(!showPlatform)}
                                                    name="platform"
                                                />
                                            }
                                            label="Platform"
                                        />

                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={showStatus}
                                                    onChange={() => setShowStatus(!showStatus)}
                                                    name="Status"
                                                />
                                            }
                                            label="Status"
                                        />

                                        {Object.keys(dspCompany).length != 0 ? (<FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={showAdvertiser}
                                                    onChange={() => setShowAdvertiser(!showAdvertiser)}
                                                    name="Advertiser"
                                                />
                                            }
                                            label="Advertiser"
                                        />) : ''}


                                        {Object.keys(managers).length != 0 ? (<FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={showManager}
                                                    onChange={() => setShowManager(!showManager)}
                                                    name="Manager"
                                                />
                                            }
                                            label="Account Managers"
                                        />) : ''}
                                    </Grid>

                                    <Grid item xs={6}>
                                        {showPlatform && (
                                            <SelectMulti
                                                label="Platform"
                                                items={platform}
                                                selectedItems={selectedPlatform}
                                                onChange={(event) => setSelectedPlatform(event.target.value)}
                                                itemLabel="name"
                                                itemKey="id"
                                                itemValue="id"
                                            />
                                        )}
                                    </Grid>
                                    <Grid item xs={6}>
                                        {showStatus && (
                                            <SelectMulti
                                                label="Status"
                                                items={status}
                                                selectedItems={selectedStatus}
                                                onChange={(event) => setSelectedStatus(event.target.value)}
                                                itemLabel="name"
                                                itemKey="id"
                                                itemValue="id"
                                            />
                                        )}
                                    </Grid>
                                    <Grid item xs={6}>
                                        {showAdvertiser && (
                                            <SelectMulti
                                                label="Advertiser"
                                                items={dspCompany}
                                                selectedItems={selectedAdvertiser}
                                                onChange={(event) => setSelectedAdvertiser(event.target.value)}
                                                itemLabel="value.name"
                                                itemKey="value.id"
                                                itemValue="value.id"
                                            />
                                        )}
                                    </Grid>
                                    <Grid item xs={6}>
                                        {showManager && (
                                            <SelectMulti
                                                label="Account Managers"
                                                items={managers}
                                                selectedItems={selectedManager}
                                                onChange={(event) => setSelectedManager(event.target.value)}
                                                itemLabel="value.name"
                                                itemKey="value.id"
                                                itemValue="value.id"
                                            />
                                        )}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>
                </AccordionDetails>
            </Accordion>

            <Grid item xs={6} md={6}>
                <Button
                    size={"large"}
                    startIcon={<BackupTableOutlinedIcon fontSize="small"/>}
                    onClick={handleSubmit}
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{marginLeft: '-15px'}}
                >
                    Generate Report
                </Button>

                <Button
                    size={"large"}
                    startIcon={<PostAddOutlinedIcon/>}
                    onClick={handleClickOpenCreate}
                    type="submit"
                    variant="contained"
                    color="success"
                    sx={{marginLeft: '15px'}}
                >
                    Create
                </Button>

                <Button
                    size={"large"}
                    startIcon={<UploadFileOutlinedIcon/>}
                    onClick={handleClickOpenUpload}
                    type="submit"
                    variant="outlined"
                    sx={{marginLeft: '15px'}}
                >
                    Upload CSV
                </Button>
            </Grid>

            <Grid item xs={6} md={6}>
                <div>
                    <div
                        ref={dropDownRef}
                        style={{
                            userSelect: 'none',
                            borderRadius: '5px',
                            textAlign: "center",
                            backgroundColor: '#f0f3f5',
                            padding: '10px',
                            cursor: 'pointer',
                            float: 'right',
                            border: '1px solid #dddfe1',
                        }}
                        onClick={toggleCalendar}
                    >
                        <div>
                            Choose Month
                        </div>
                        <div>
                            <MonthPickerComponent onMonthChange={handleMonthChange} initialMonthYear={getPreviousMonthString()}/>
                        </div>
                    </div>
                </div>
            </Grid>

            <CreateRowDialog
                open={openCreate}
                handleClose={handleCloseCreate}
                dsp={dspCompany}
                onSuccess={handleSubmit}
            />

            <UploadFileDialog
                open={openUpload}
                handleClose={handleCloseUpload}
                templateLink={templateLink}
                onSuccess={handleSubmit}
            />
        </Grid>
    );
}

export default TotalRevenueOptionsForm;
